import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CoreConfigService } from '../../../../@core/services/config.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  providers: [TranslatePipe]
})
export class PrivacyPolicyComponent implements OnInit {
  public coreConfig: any;
  public previousPrivacyPolicy = '';

  constructor(private _coreConfigService: CoreConfigService) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false
      }
    };
  }

  ngOnInit(): void {
    this.previousPrivacyPolicy = environment.privacyPolicyPrevVersion;
  }
}
